import RYBConnectClasses from "../../common/services/classes.service";
import { APP_VERSION } from "../../common/services/default-category.service";
import { URL_PARAMETERS } from "../../common/utils/const.util";
import { handleUnexpectedError } from "../../common/utils/errors.util";
import { getUrlParameterValue } from "../../common/utils/url.util";
import { processResult } from "../finder/services/result.service";
import { ChildService } from "./services/child.service";
import { ClassesService } from "./services/classes.service";
import { ParentService } from "./services/parent.service";
declare global {
  interface Window {
    google: typeof google;
    initMap: () => void;
  }
}
$(async () => {
  try {
    const dataManager = new RYBConnectClasses();
    console.log(`RYB Connect ${APP_VERSION}`);
    ParentService.addEventListeners();
    const result = await dataManager.getData();
    await ChildService.addEventListeners();
    await ClassesService.addEventListener();
    const isResultStep = getUrlParameterValue(URL_PARAMETERS.STEP) === "3";
    const isCalendarShortcode = document.querySelector(
      `#ryb-connect[data-shortcode-type="finder"]`
    );
    if (isResultStep || isCalendarShortcode) {
      processResult();
    }

    if (result) {
      $(".step-loading").removeClass("active");
    }
  } catch (error) {
    console.error("Error initializing wizard:", error);
    handleUnexpectedError("", "", error);
  }
});
